const i18n = require('i18next');
const XHR = require('i18next-xhr-backend');
const config = require('./config');

const options = {
  fallbackLng: 'en',
  load: 'languageOnly',
  ns: ['common'],
  defaultNS: 'common',
  fallbackNS: 'common',
  debug: false,
  keySeparator: false,
  nsSeparator: false,
  pluralSeparator: false,
  contextSeparator: false,
  backend: {
    loadPath: config.cdn.localesPath + '{{lng}}.json',
    crossDomain: true,
  },
};

if (!config.isServer) {
  i18n.use(XHR);
}

// initialize if not already initialized
if (!i18n.isInitialized) {
  i18n.init(options);
}

// a simple helper to getInitialProps passed on loaded i18n data
i18n.getInitialProps = (req, namespaces) => {
  if (!namespaces) namespaces = i18n.options.defaultNS;
  if (typeof namespaces === 'string') namespaces = [namespaces];

  if (!req.i18n) return {};

  // do not serialize i18next instance and send to client
  req.i18n.toJSON = () => null;

  return {
    i18n: req.i18n,
    initialI18nStore: {},
    initialLanguage: req.i18n.language,
  };
};

module.exports = i18n;



// WEBPACK FOOTER //
// ./config/i18n.js